<template>
<teleport to="body">
  <div v-if="loading" class="preloader">
    <BehfamLOGO name="در حال بارگذاری..."/>
  </div>
</teleport>
</template>

<script>
import BehfamLOGO from "@/components/Icons/BehfamLOGO.vue";

export default {
  components: {BehfamLOGO},
  props: {
    loading: {
      type: Boolean,
      required: true,
    }
  },
};
</script>

<style scoped>
.preloader {
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.9);
  position: fixed;
  top: 0;
  right: 0;
  z-index: 999999999999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
